import { useState } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Globe } from '@phosphor-icons/react';
import { AuthHeading } from '../../../../../components/auth/auth-heading';
import { OnboardingHeader } from '../../../../../components/auth/onboarding-header';
import { Button } from '../../../../../components/ui/button';
import { Checkbox } from '../../../../../components/ui/checkbox';
import { Input } from '../../../../../components/ui/input';
import { validateUrl } from '../../../../../lib/onboarding';
import { useOnboardingStore } from '../../../../../lib/onboarding-store';

export const Route = createFileRoute('/subdomain/app/_auth/onboarding/website')({
  component: WebsiteStep,
});

function WebsiteStep() {
  const navigate = useNavigate();
  const { draft, updateDraft } = useOnboardingStore();
  const [touched, setTouched] = useState(false);

  const error = draft.hasWebsite && touched ? validateUrl(draft.websiteUrl) : undefined;
  const canContinue = draft.hasWebsite ? draft.websiteUrl.trim().length > 0 && !validateUrl(draft.websiteUrl) : true;

  return (
    <>
      <OnboardingHeader step={3} backTo="/subdomain/app/onboarding/business" />
      <AuthHeading title="Do you have a website?" subtitle="We’ll check its speed and SEO in your free audit." />

      <Input
        label="Website address"
        leadingIcon={Globe}
        inputMode="url"
        autoComplete="url"
        disabled={!draft.hasWebsite}
        value={draft.hasWebsite ? draft.websiteUrl : ''}
        error={error}
        helperText="Include the full address, like yourbusiness.com"
        onChange={(e) => updateDraft({ websiteUrl: e.target.value })}
        onBlur={() => setTouched(true)}
      />

      <div className="flex items-center gap-(--mbm-space-3)" aria-hidden>
        <span className="h-px flex-1 bg-border-line" />
        <span className="text-body-small text-text-tertiary">or</span>
        <span className="h-px flex-1 bg-border-line" />
      </div>

      <div className="rounded-(--mbm-radius-md) border border-border-input p-(--mbm-space-4)">
        <Checkbox
          checked={!draft.hasWebsite}
          onChange={(e) =>
            updateDraft({ hasWebsite: !e.target.checked, websiteUrl: e.target.checked ? '' : draft.websiteUrl })
          }
          label={
            <span className="flex flex-col">
              <span className="text-label-large text-text-primary">I don’t have a website yet</span>
              <span className="text-body-xsmall text-text-tertiary">No website? We can build one in 24 hours.</span>
            </span>
          }
        />
      </div>

      <Button fullWidth disabled={!canContinue} onClick={() => navigate({ to: '/subdomain/app/onboarding/socials' })}>
        Continue
      </Button>
    </>
  );
}
